import React, { useState } from 'react';
import { PlusIcon, FilterIcon, MapIcon, ListIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { DiveCard } from '../components/dive/DiveCard';
import { Link } from 'react-router-dom';
export const DiveLog: React.FC = () => {
  const [view, setView] = useState<'list' | 'map'>('list');
  // Sample dive data
  const dives = [{
    id: '1',
    location: 'Great Barrier Reef',
    date: 'June 15, 2023',
    depth: 18,
    duration: 45,
    temperature: 24,
    hasPhotos: true
  }, {
    id: '2',
    location: 'Blue Corner, Palau',
    date: 'May 22, 2023',
    depth: 30,
    duration: 52,
    temperature: 27,
    hasPhotos: true
  }, {
    id: '3',
    location: 'Molokini Crater, Maui',
    date: 'April 10, 2023',
    depth: 15,
    duration: 38,
    temperature: 25,
    hasPhotos: false
  }, {
    id: '4',
    location: 'SS Yongala, Australia',
    date: 'March 5, 2023',
    depth: 28,
    duration: 49,
    temperature: 26,
    hasPhotos: true
  }, {
    id: '5',
    location: 'Silfra Fissure, Iceland',
    date: 'February 18, 2023',
    depth: 12,
    duration: 35,
    temperature: 2,
    hasPhotos: true
  }];
  return <div data-id="element-1012">
      <div className="flex items-center justify-between mb-6" data-id="element-1013">
        <h1 className="text-2xl font-bold text-navy" data-id="element-1014">Dive Log</h1>
        <Link to="/dives/new" data-id="element-1015">
          <Button variant="primary" icon={<PlusIcon size={16} data-id="element-1017" />} data-id="element-1016">
            New Dive
          </Button>
        </Link>
      </div>
      <div className="flex justify-between items-center mb-4" data-id="element-1018">
        <Button variant="outline" size="sm" icon={<FilterIcon size={16} data-id="element-1020" />} data-id="element-1019">
          Filter
        </Button>
        <div className="flex border rounded-lg overflow-hidden" data-id="element-1021">
          <button className={`px-3 py-1.5 ${view === 'list' ? 'bg-primary text-white' : 'bg-white text-gray-600'}`} onClick={() => setView('list')} data-id="element-1022">
            <ListIcon size={18} data-id="element-1023" />
          </button>
          <button className={`px-3 py-1.5 ${view === 'map' ? 'bg-primary text-white' : 'bg-white text-gray-600'}`} onClick={() => setView('map')} data-id="element-1024">
            <MapIcon size={18} data-id="element-1025" />
          </button>
        </div>
      </div>
      {view === 'list' ? <div className="space-y-4" data-id="element-1026">
          {dives.map(dive => <DiveCard key={dive.id} dive={dive} data-id="element-1027" />)}
        </div> : <div className="bg-gray-100 rounded-lg h-96 flex items-center justify-center" data-id="element-1028">
          <p className="text-gray-500" data-id="element-1029">Map view will be implemented here</p>
        </div>}
    </div>;
};